import { LinearProgress, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import useSetInterval from "@entrilia/shared/hooks/useSetInterval";
import { wait } from "@entrilia/shared/utilities/promiseHelper";

const TICK_MS = 1000;
const STEP = 7;
const CAP_BEFORE_DONE = 92;
const HOLD_AT_FULL_MS = 500;

interface Props {
  done: boolean;
  onDone: () => void;
}

const CheckingProgress = ({ done, onDone }: Props) => {
  const [progress, setProgress] = useState(STEP);
  const finalizedRef = useRef(false);

  useSetInterval(() => setProgress((current) => Math.min(current + STEP, CAP_BEFORE_DONE)), TICK_MS, {
    disabled: done,
  });

  useEffect(() => {
    if (!done || finalizedRef.current) {
      return;
    }
    finalizedRef.current = true;
    wait(HOLD_AT_FULL_MS).then(onDone);
  }, [done, onDone]);

  const displayValue = done ? 100 : progress;

  return (
    <Paper variant="outlined" sx={{ width: "100%", bgcolor: "background.grey", p: 2 }}>
      <Stack spacing={1.5}>
        <Typography variant="subtitle1">Checking access...</Typography>
        <LinearProgress variant="determinate" value={displayValue} />
      </Stack>
    </Paper>
  );
};

export default CheckingProgress;
